import React,{Component} from 'react';
import Quiz from './Quiz'
// import Navbar from './Navbar'
import Main from './Main'


class App extends Component {

  render(){
  return (
    <div>
      <Main/> 
      {/* the main component consists of homepage */}
    </div>
  );
}
}
export default App;
